import { BasicType, BlockType } from "@/constants";

const iconsMap = {
   [BasicType.TEXT]: "icon-text",
   [BasicType.SECTION]: "icon-section",
   [BasicType.COLUMN]: "icon-column",
   [BasicType.DIVIDER]: "icon-divider",
   [BasicType.IMAGE]: "icon-img",
   [BasicType.BUTTON]: "icon-button",
   [BasicType.GROUP]: "icon-group",
   [BasicType.PAGE]: "icon-page",
   [BasicType.WRAPPER]: "icon-wrapper",
   [BasicType.NAVBAR]: "icon-navbar",
   [BasicType.HERO]: "icon-hero",
   [BasicType.SPACER]: "icon-spacing",
   [BasicType.SOCIAL]: "icon-soc",
   [BasicType.CAROUSEL]: "icon-carousel",
   [BasicType.ACCORDION]: "icon-accordion",
   [BasicType.TABLE]: "icon-wrapper",
};

export function getIconNameByBlockType(type: BlockType) {
   return iconsMap[type] || "icon-number";
}
